/* eslint-disable prettier/prettier */
/* eslint-disable */

import { GET_USER_SETTINGS, SAVE_VISIBILITY_SETTINGS } from 'actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponseObject, IUserSettingsResponse } from 'api/types';
import connectReducers from 'utils/connectReducers';

import { IReducers } from '.';
import genericReducers from './genericReducer';

export type UserSettingsState = ICommonResponseObject<IUserSettingsResponse | null>;

const initialState: UserSettingsState = {
  content: null,
  loading: false,
};
const generic = genericReducers<UserSettingsState>();
const userSettings: IReducers<UserSettingsState> = {
  [GET_USER_SETTINGS[REQUEST]]: generic.get.request,
  [GET_USER_SETTINGS[SUCCESS]]: generic.get.success,
  [GET_USER_SETTINGS[FAILURE]]: generic.get.failure,
  [GET_USER_SETTINGS[INVALIDATE]]: generic.get.invalidate(initialState),

  [SAVE_VISIBILITY_SETTINGS[REQUEST]]: generic.createUpdate.request,
  [SAVE_VISIBILITY_SETTINGS[SUCCESS]]: generic.createUpdate.success,
  [SAVE_VISIBILITY_SETTINGS[FAILURE]]: generic.createUpdate.failure,
};

export default connectReducers(initialState, userSettings);
